<template>
	<div class="flex h-dvh w-full flex-col overflow-hidden bg-muted pb-safe">
		<div class="flex min-h-0 flex-1 flex-col gap-10 p-6 sm:p-10">
			<div class="flex items-center justify-between">
				<AuthHeader />
				<UserSessionBar />
			</div>

			<!-- Each step owns its own max-width (see the step pages) so the width
				travels with the out-in page transition instead of flipping on the
				persistent layout the moment the route resolves. -->
			<div class="flex min-h-0 flex-1 flex-col">
				<section class="m-auto flex max-h-200 min-h-0 w-full flex-col">
					<slot />
				</section>
			</div>
		</div>
	</div>
</template>
